import React from 'react';

export default function ManageUserDetail() {
  return <div>manage User Details Form</div>;
}
